import confetti from 'canvas-confetti';
import {base} from '../enums/brand_colors';

const pearShape = confetti.shapeFromPath({path: 'M -6 0 C -6.495 2.236 -7.565 1.787 -8.006 4.361 C -8 9 -5 9 -3 9 C -1 9 2 9 1.997 4.251 C 1.503 1.749 0.579 2.212 0 0 C 0 -2 -1 -3 -3 -3 C -3 -4 -3 -6 -1 -6 C -1 -4 -2.3333 -4 -3 -3 C -5 -3 -6 -2 -6 0'}),
      shapes = ['square', 'star', 'circle', pearShape];
export function shootConfetti(confettiOptions) {
  confetti({
    particleCount: 200,
    spread: 300,
    zIndex: 9999,
    disableForReducedMotion: true,
    colors: Object.values(base),
    shapes,
    ...confettiOptions,
  });
}
export function shootRandomConfetti(confettiOptions) {
  const randomShape = shapes[Math.floor(Math.random() * shapes.length)];
  confetti({
    particleCount: 200,
    spread: 300,
    zIndex: 9999,
    disableForReducedMotion: true,
    colors: Object.values(base),
    shapes: [randomShape],
    ...confettiOptions,
  });
}
